<main class="main mt-3">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Sitelink:</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
            ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <app-block-text
            [maxLength]="25"
            [type]="'content'"
            [blockData]="block.variables?.['Text'] ?? ''"
            (handleOnChange)="onChange($event, 'Text')"
            [placeholder]="textPlaceholder"
            variable="Text"
            [isPlainText]="true"
            [blockId]="block.blockId"
            [restrictContent]="true"
          ></app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [maxLength]="35"
            [type]="'content'"
            [blockData]="block.variables?.['FirstDescriptionLine'] ?? ''"
            (handleOnChange)="onChange($event, 'FirstDescriptionLine')"
            [placeholder]="firstDescriptionLinePlaceholder"
            variable="FirstDescriptionLine"
            [isPlainText]="true"
            [blockId]="block.blockId"
            [canBeEmpty]="true"
            [restrictContent]="true"
          ></app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [maxLength]="35"
            [type]="'content'"
            [blockData]="block.variables?.['SecondDescriptionLine'] ?? ''"
            (handleOnChange)="onChange($event, 'SecondDescriptionLine')"
            [placeholder]="secondDescriptionLinePlaceholder"
            variable="SecondDescriptionLine"
            [isPlainText]="true"
            [blockId]="block.blockId"
            [canBeEmpty]="true"
            [restrictContent]="true"
          ></app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [maxLength]="4000"
            [type]="'link'"
            [blockData]="block.variables?.['SitelinkLink'] ?? ''"
            (handleOnChange)="onChange($event, 'SitelinkLink')"
            [placeholder]="sitelinkLinkPlaceholder"
            variable="SitelinkLink"
            [isPlainText]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
      </div>
    </div>
  </div>
</main>
